module.exports = __webpack_public_path__ + "static/media/Normativa.fcc2e721.jpg";